<template>
    <b-button type="is-primary" size="is-small" @click="openModal" icon-left="plus">Crear Cama</b-button>
</template>
<script>
import ModalCreateBed from './ModalCreateBed';
 export default {    
    methods: {
      openModal() {
        this.$buefy.modal.open({
          parent: this,
          component: ModalCreateBed,          
          hasModalCard: true,
          trapFocus: true,
        });
      },
    },
  };
</script>